import React from 'react'

import Card from '../../../../../components/Card'

import * as S from './styles'

function LoadingCards () {
  return (
    <S.WrapperCards>
      {Array(5).fill().map((item, index) => <S.StyledCard key={index}><Card full loading skeletonHeight={137} /></S.StyledCard>)}
    </S.WrapperCards>
  )
}

export default LoadingCards
